import { TaskPhase, TaskStatus } from '#/protobuf/task_pb';

// the statuses we show in badges for jobs and their tasks.
export const STATUS_DESCRIPTION = {
  UNKNOWN: 'No Status',
  WAITING: 'Waiting',
  PAUSED: 'Paused',
  WORKING: 'Working',
  DONE: 'Done',
  CANCELED: 'Canceled',
  ERRORED: 'Errored',
};
export function taskIsCompleted(task) {
  if (task.info.taskStatus === TaskStatus.DONE) {
    return true;
  }
  return false;
}
// checks if the task has errors
export function taskIsErrored(task) {
  if (task.info.taskStatus === TaskStatus.STATUS_ERRORED) {
    return true;
  }
  // see if we've got un-recovered errors
  // protect against taskStatus being no error but actually having un-recovered errors
  if (task.info.taskErrorsList && task.info.taskErrorsList.length > 0 && task.info.taskStatus !== TaskStatus.STATUS_RECOVERED) {
    return true;
  }
  return false;
}

export function taskStatusDescription(task) {
  if (taskIsErrored(task)) {
    // short circuit out with "Errored" if applicable
    return STATUS_DESCRIPTION.ERRORED;
  }

  switch (task.info.taskPhase) {
    case TaskPhase.PHASE_WAITING:
      return STATUS_DESCRIPTION.WAITING;
    case TaskPhase.PHASE_PAUSED:
      return STATUS_DESCRIPTION.PAUSED;
    case TaskPhase.PHASE_WORKING:
      return STATUS_DESCRIPTION.WORKING;
    case TaskPhase.PHASE_CANCELED:
      return STATUS_DESCRIPTION.CANCELED;
    case TaskPhase.PHASE_DONE:
      return STATUS_DESCRIPTION.DONE;
    default:
      return STATUS_DESCRIPTION.UNKNOWN;
  }
}
